import { useInfiniteQuery } from '@tanstack/react-query'
import { getTasksPaginated, TASKS_PAGE_SIZE } from '@/services/tasksService'
import { useAuth } from '@/hooks/useAuth'
import type { TasksPage } from '@/services/tasksService'
import { INFINITE_TASKS_KEY } from '@/constants/queryKeys'
import type { QueryDocumentSnapshot, DocumentData } from 'firebase/firestore'

export function useInfiniteTasks() {
  const { churchId } = useAuth()

  return useInfiniteQuery<
    TasksPage,
    Error,
    {
      pages: TasksPage[]
      pageParams: (QueryDocumentSnapshot<DocumentData> | null)[]
    },
    string[],
    QueryDocumentSnapshot<DocumentData> | null
  >({
    queryKey: [INFINITE_TASKS_KEY, churchId!],
    queryFn: ({ pageParam }) => getTasksPaginated(churchId!, pageParam),
    initialPageParam: null,
    getNextPageParam: (lastPage) =>
      lastPage.tasks.length < TASKS_PAGE_SIZE ? undefined : lastPage.lastDoc,
    enabled: !!churchId,
  })
}
